import { client } from './client';

// --- Reminders ---

export const getReminders = async () => {
    const response = await client.get('/v1/reminders');
    return response.data?.items ?? response.data;
};

export const createReminder = async (data) => {
    const response = await client.post('/v1/reminders', data);
    return response.data;
};

export const updateReminder = async (uid, data) => {
    const response = await client.put(`/v1/reminders/${uid}`, data);
    return response.data;
};

export const deleteReminder = async (uid) => {
    const response = await client.delete(`/v1/reminders/${uid}`);
    return response.data;
};

export const advanceReminder = async (uid) => {
    const response = await client.post(`/v1/reminders/${uid}/advance`);
    return response.data;
};
